import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App            from './app/App.tsx';
import '@/assets/css/site.css';
import './app/i18n.ts';

const root = document.getElementById('root');

if (!root) throw new Error('No root element found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
